import {connect} from 'react-redux';
import compose from 'recompose/compose';
import lifecycle from 'recompose/lifecycle';
import withState from 'recompose/withState';
import mapProps from 'recompose/mapProps';
import {getStatus} from 'redux-resource';
import {readCollection} from '../../../../redux/actions/collections';
import {readFile} from '../../../../redux/actions/files';
import {setTitle} from '../../../../redux/actions/page';
import {getDownloadURL} from '../../../../firebase/storage/download';
import collect from '../../../../services/analytics/collector';
import cancelable from '../../../../../util/cancelable-promise';
import VideoView from './video-view';

function mapStateToProps(state, props) {
	const {
		match: {
			params: {
				fileId
			} = {}
		} = {}
	} = props;
	const status = getStatus(state, `files.meta[${fileId}].readStatus`);
	const file = state.files.resources[fileId];

	return {
		status,
		file
	};
}

function mapDispatchToProps(dispatch, props) {
	return {
		read() {
			const {
				match: {
					params: {
						collectionId,
						fileId
					} = {}
				} = {}
			} = props;

			dispatch(readCollection(collectionId))
				.then(collections => collections[0])
				.then(collection => dispatch(setTitle(collection.name)));
			return dispatch(readFile(fileId));
		}
	};
}

const enhance = compose(
	connect(mapStateToProps, mapDispatchToProps),
	withState('url', 'setURL', ''),
	withState('status', 'setLoadedState', {isLoaded: false}),
	withState('numPages', 'setNumPages', 0),
	lifecycle({
		componentWillMount() {
			const {props: {read, history}, setState} = this;

			read().then(() => {
				const {
					props: {
						file: {
							name, id, collection, media
						}
					}
				} = this;

				if (!name) {
					history.replace('/not-found');
				}

				collect(collection, id);

				const fetchURLTask = cancelable(getDownloadURL(`${collection}/${media}`));

				setState({fetchURLTask});
				return fetchURLTask.promise;
			}).then(url => setState({url}));
		},
		componentWillUnmount() {
			const {state} = this;

			if (state && state.fetchURLTask) {
				state.fetchURLTask.cancel();
			}
		}
	}),
	mapProps(({file, url, setNumPages}) => ({file: file || {}, url: url || '', setNumPages}))
);

export default enhance(VideoView);



// WEBPACK FOOTER //
// ./src/client/components/main/files/video/index.js